export const FirebaseConfig = {
	"apiKey": "AIzaSyB-KgXUSAWuirHlbTcgp2-sGIDJ-fjmTns",
	"authDomain": "guru-assistencia.firebaseapp.com",
	"projectId": "guru-assistencia",
	"storageBucket": "guru-assistencia.firebasestorage.app",
	"messagingSenderId": "794183129312",
	"appId": "1:794183129312:web:c41dae1ab38350abb45885",
	"measurementId": "G-8D9W6Z4P09"
}; 